<ng-template #chatModalTemplate>
  <button
    type="button"
    class="info-modal-close"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <svg-icon
      class="icon-close"
      [src]="'../../../assets/images/icons/close.svg'"
    ></svg-icon>
  </button>
  <app-user-message-thread #messageThread></app-user-message-thread>
</ng-template>
